import { Commit, Dispatch, Module } from "vuex";
import { RootState } from "@/store";
import { message } from "ant-design-vue";
import { t } from "@/plugins/i18n";
import {
  getAssessmentReportList,
  AssessmentReportListParams,
  assessmentReportAudit,
  AssessmentReportAuditParams,
} from "@/api/userCenter";
import dayjs from "dayjs";

type assessmentMethod = {
  assessmentMethodId: number;
  assessmentMethod: string;
};
type assessmentItem = {
  id: number;
  datasetName: string;
  datasetId: number;
  createUser: string;
  assessmentMethodList: assessmentMethod[];
  description: string;
  createTime: number;
};
interface State {
  assessmentList: assessmentItem[];
  assessmentListPage: {
    pageNo: number;
    pageSize: number;
    totalPage: number;
  };
}

const store: Module<State, RootState> = {
  namespaced: true, // 为每个模块添加一个前缀名，保证模块命明不冲突
  state: () => {
    return {
      assessmentList: [],
      assessmentListPage: {
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
      },
    };
  },
  mutations: {
    setAssessmentList(state: State, payload) {
      const { data: list, page } = payload || {
        data: [],
        page: { count: 0 },
      };
      state.assessmentList = list.map((item: assessmentItem) => {
        return {
          ...item,
          createTime: dayjs(item.createTime).format("YYYY/MM/DD HH:mm:ss"),
        };
      });
      state.assessmentListPage = page;
    },
  },
  actions: {
    async getAssessmentList(
      { commit }: { commit: Commit },
      params: AssessmentReportListParams = {}
    ) {
      try {
        const res = await getAssessmentReportList(params);
        commit("setAssessmentList", res);
      } catch (error) {
        log.error(error, "error");
      }
    },
    async assessmentReportAudit(
      {
        commit: _commit,
        dispatch,
        state,
      }: { commit: Commit; dispatch: Dispatch; state: State },
      params: AssessmentReportAuditParams
    ) {
      try {
        await assessmentReportAudit(params);
        dispatch("getAssessmentList", {
          pageNo: state.assessmentListPage.pageNo,
          pageSize: state.assessmentListPage.pageSize,
        });
        message.success(
          t(
            params.auditState === 1
              ? "userCenter.auditSuccess"
              : "userCenter.rejectSuccess"
          )
        );
      } catch (error) {
        log.error(error, "error");
        message.error(t("userCenter.auditFail"));
      }
    },
  },
};

export default store;
